import React from 'react';
import { useAtomValue } from 'jotai';
import type { BrushAnnotationT } from '../../../types';
import { currentFrameAnnotationBitmapsAtom } from '../atoms/segmentation-atoms';
import { getOptimizedCentroid } from '../canvas/utils';
import AnnotationLabel from '../shape/annotation-label';
type Props = {
  annotation: BrushAnnotationT;
  annotationIdx: string;
};
const SegmentationAnnotation = ({
  annotation,
  annotationIdx
}: Props) => {
  const annotationBitmaps = useAtomValue(currentFrameAnnotationBitmapsAtom);
  const annotationBitmap = annotationBitmaps[annotation.annotationLabel.title];
  if (!annotationBitmap) {
    return null;
  }
  const centroid = getOptimizedCentroid(annotationBitmap);
  return centroid ? <g data-e2e-id={`annotation-${annotation.annotationLabel.title}-${annotation.annotationType}`} data-annotation-id={annotationIdx}>
      <AnnotationLabel label={annotation.annotationLabel.title} labelCoords={[centroid.x, centroid.y]} annotationStyle={annotation.annotationLabel.style} hideLabelPointer={false} />
    </g> : null;
};
export default SegmentationAnnotation;